import styled, { css, DefaultTheme } from 'styled-components';
import { ColorScheme } from 'ia-react-core/~/interfaces/ColorScheme';
import media from '../../../utils/styling/media';
import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';
import { MainContentProps } from './MainContent';

export const StyledContent = styled.main<{
  scheme: ColorScheme;
} & MainContentProps>`
  min-width: ${({ theme, minContentWidth }) => minContentWidth || theme.layout.minContentWidth}px;
  background: ${({ theme, scheme, background }) => {
    if (background) {
      return background;
    }

    if (theme.layout.contentBackground) {
      return theme.layout.contentBackground;
    }

    return scheme === COLOR_SCHEMES.SHADE ? theme.colors.gray1 : theme.colors.white;
  }};
  background-repeat: ${({ backgroundRepeat }) => backgroundRepeat};
  background-size: ${({ backgroundSize }) => backgroundSize};
  background-position: ${({ backgroundPosition }) => backgroundPosition};
  background-attachment: ${({ backgroundAttachment }) => backgroundAttachment};

  ${({ fullHeight }) => fullHeight && css`
    display: flex;
    flex: 1;
  `}
`;

const xsPadding = ({ theme, nopadding, horizontalPadding, verticalPadding }: MainContentProps & { theme: DefaultTheme }) => {
  if (nopadding) {
    return '0';
  }

  const vp = verticalPadding || theme.layout.contentVerticalPadding || 48;
  const hp = horizontalPadding || theme.layout.contentHorizontalPadding || 8;

  return (
    `${vp}px ${hp}px`
  );
};

const lgPadding = ({ theme, nopadding, horizontalPadding, verticalPadding }: MainContentProps & { theme: DefaultTheme }) => {
  if (nopadding) {
    return '0';
  }

  const vp = verticalPadding || theme.layout.lgContentVerticalPadding || 60;
  const hp = horizontalPadding || theme.layout.lgContentHorizontalPadding || 8;

  return (
    `${vp}px ${hp}px`
  );
};

export const StyledContentContainer = styled.div<MainContentProps>`
  max-width: ${({ theme, maxContentWidth }) => maxContentWidth || theme.layout.maxContentWidth}px;
  margin: 0 auto;
  padding: ${xsPadding};

  ${({ contentHeight }) => contentHeight && css`
    height: ${contentHeight};
  `}

  ${media.lg`
    padding: ${lgPadding};
  `}

  ${({ fullHeight }) => fullHeight && css`
    display: flex;
    flex: 1;
    flex-direction: column;
  `}
`;
